import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

export const firebase = initializeApp({
  apiKey: "AIzaSyBjOv4oq-Ph982_mHuOrQxSdA3-jLw2r4E",
  authDomain: 'auth.wisery.io',
  // authDomain: "learn-8c4ef.firebaseapp.com",
  projectId: "learn-8c4ef",
  storageBucket: "learn-8c4ef.appspot.com",
  messagingSenderId: "643278908363",
  appId: "1:643278908363:web:3190bfc1e0bb00e840644e",
  measurementId: "G-WX27S7QKV9",
  locationId: "asia-southeast2",
});

export const db = getFirestore(firebase);
export const functions = getFunctions(firebase, "asia-southeast2");

// const functionsEm = getFunctions(firebase);

// try {
//   if (location.hostname === "localhost") {
//     connectFirestoreEmulator(db, "localhost", 8080);
//     // connectAuthEmulator(auth, "http://localhost:9099");
//     // add more services as described in the docs: https://firebase.google.com/docs/emulator-suite/connect_firestore
//   }
// } catch (error) {
//   console.error(error);
// }
